export default "__VITE_ASSET__CECb42HZ__"